export { getParkAggregatesQuestion, ParkAggregatesAnswer } from './ParkAggregatesFaq';
